
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const BrandingButton = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="fixed bottom-4 right-4 z-50 px-6 py-3 bg-white rounded-lg shadow-[0_2px_15px_-3px_rgba(0,0,0,0.2)] hover:shadow-[0_2px_15px_-3px_rgba(0,0,0,0.4)] transition-shadow duration-200">
          <img 
            src="/lovable-uploads/915cb4d1-ab92-43c8-b8aa-fbda05c4f5a3.png" 
            alt="Blacktide" 
            className="w-24 h-auto"
          />
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <img 
              src="/lovable-uploads/915cb4d1-ab92-43c8-b8aa-fbda05c4f5a3.png" 
              alt="Blacktide" 
              className="w-24 h-auto"
            />
          </div>
          <DialogDescription className="text-center">
            Do you want to remove branding? Or upgrade and scale your dashboard with more integrations?
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-4">
          <Button
            onClick={() => window.location.href = 'mailto:Accounts@BlacktideMarketing.com'}
            className="w-full sm:w-auto"
          >
            Learn More
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BrandingButton;
